import { FileUploadInterface } from './Profile';

export interface Inward {
  id: string;
  assetId: string;
  assetName: string;
  element: string;
  totalNumberOfElement: string;
  borrowerName: string;
  inwardDateTime: string;
  comments: string;
  isActive: boolean;
  isVerified: boolean;
  verfyComments: string;
  isApproved: boolean;
  approveComments: string;
  pickerName: string;
  pickerPhoneNumber: string;
  isPickerAssigned: boolean;
  isMoved: boolean;
  moveToVaultComments: string;
  files: FileUploadInterface[];
}

export const InwardInitialState = {
  id: '',
  assetId: '',
  assetName: '',
  element: '',
  totalNumberOfElement: '',
  borrowerName: '',
  inwardDateTime: '',
  comments: '',
  isActive: false,
  isVerified: false,
  verifyComments: '',
  isApproved: false,
  approveComments: '',
  pickerName: '',
  pickerPhoneNumber: '',
  isMoved: false,
  moveToVaultComments: '',
  isPickerAssigned: false,
  files: [],
};
